const app = {
  cookie: {
    get: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    set: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  },

  cookiesPopup: {
    init: function() {
      const acceptedCookies = app.cookie.get('acceptCookies'),
            cookiePopup = document.querySelector('.cookie-popup'),
            cookiePopupInner = document.querySelector('.cookie-popup__inner'),
            cookiePopupClose = document.querySelector('.cookie-popup__close'),
            cookiePopupAccept = document.querySelector('#cookies-agreement');

      if (cookiePopupInner) {
        if(!acceptedCookies || acceptedCookies != '1') {
          setTimeout(function() {
            cookiePopup.classList.remove('cookie-popup--disabled');
            cookiePopup.classList.add('cookie-popup--open');
          }, 1500);
        }

        cookiePopupClose.addEventListener('click', function(e) {
          cookiePopup.classList.remove('cookie-popup--open');
          setTimeout(() => cookiePopup.classList.add('cookie-popup--disabled'), 405);
        }); 

        cookiePopupAccept.addEventListener('click', function(e) {
          cookiePopup.classList.remove('cookie-popup--open');
          app.cookie.set('acceptCookies','1','360');
          setTimeout(() => cookiePopup.classList.add('cookie-popup--disabled'), 405);
        });
      }
    }
  },
  
  cartPage: {
    company: function() {
      const el = {
        cartIcon: document.querySelectorAll('.js-drawer-open-cart'),
        form: document.querySelector('.page-content .cart'),
        checkbox: document.querySelector('#need-invoice-static'),
        box: document.querySelector('#invoice-needed-static'),
        fields: document.querySelectorAll('#invoice-needed-static .input-full'),
        company: {
          name: document.querySelector('#CartCompanyName-Static'),
          address: document.querySelector('#CartCompanyAddress-Static'),
          city: document.querySelector('#CartCompanyCity-Static'),
          zip: document.querySelector('#CartCompanyZip-Static'),
          vat: document.querySelector('#CartCompanyVat-Static')
        }
      };
      
      (el.cartIcon.length > 0) && el.cartIcon.forEach(function(icon) {
        icon.classList.remove('js-drawer-open-cart');
        icon.addEventListener('click', function(e) {
          e.preventDefault();
          window.top.location.reload();
        });
      });
      
      el.checkbox.addEventListener('change', function() {
        const isChecked = (el.checkbox.checked) ? true : '';
        
        if (isChecked == true) {
          el.box.classList.add('visible');
          theme.cart.updateAttribute('NeedInvoice','true');
        } else { 
          el.box.classList.remove('visible');
          
          el.company.name.value = '';
          el.company.address.value = '';
          el.company.city.value = '';
          el.company.zip.value = '';
          el.company.vat.value = '';
          
          theme.cart.updateAttributes({ 
            attributes: {
              'NeedInvoice': '',
              'CompanyName': '',
              'CompanyAddress': '',
              'CompanyCity': '',
              'CompanyZip': '',
              'CompanyVat': '',
              'InvoiceDetails': ''
            } 
          });
        }
      });
      el.fields.forEach(function(field) {
        field.addEventListener('change', function() {
          const details = `${el.company.name.value}\n${el.company.address.value}\n${el.company.zip.value} ${el.company.city.value}\n${el.company.vat.value}`,
                attr = { attributes: {} };
          
          attr.attributes[field.name] = field.value;
          attr.attributes['InvoiceDetails'] = details;
          theme.cart.updateAttributes(attr);
        });
      });
    },
    init: function() {
      const cartPage = document.querySelector('.template-cart');
      if (cartPage) {
        app.cartPage.company(); 
      }
    }
  },

	paymentButtons: {
		init: function() {

		}
	},

  mBtns: {
    init: function() {
      let btns = document.querySelectorAll('[data-m-btn]');
      if (btns) {
        [].forEach.call(btns, function(e) {
          e.addEventListener('mouseenter', function(){
            let v = e.getAttribute('data-m-btn'),
                f = document.querySelector('[data-m-image="'+v+'"]');
            if (f) {
              f.classList.add('is-active');
              if (f.hasAttribute('data-m-image-src')) {
                f.style.backgroundImage = "url("+f.getAttribute('data-m-image-src')+")";
                f.removeAttribute('data-m-image-src');
              }
            } 
          });
          e.addEventListener('mouseleave', function(){
            let v = e.getAttribute('data-m-btn'),
                f = document.querySelector('[data-m-image="'+v+'"]');
            if (f) {
              f.classList.remove('is-active');
            } 
          });
        });
      }
    }
  },

  mProductBtns: {
    init: function() {
      let url = window.location.href,
          url_params = new URLSearchParams(window.location.search),
          url_params_size = url_params.get('size');

      window.onload = function () {
        if (url.indexOf('?size=') != -1 && url_params_size) {
          let e = document.querySelector('.variant-input-wrap[name="Size"] .variant-input[data-eq="'+url_params_size+'"] input');
          if (e) {
            e.click();
          }
        }
      }

      let btns = document.querySelectorAll('.product-single__meta [data-m-btn]');
      if (btns) {
        [].forEach.call(btns, function(e) {
          e.addEventListener('click', function(f){
            f.preventDefault();

              let size_radio = document.querySelector('.variant-input-wrap[name="Size"] input:checked'),
                  href_value = f.target.getAttribute('href'); 

              if (size_radio) {
                if (href_value.indexOf('?size') == -1) {
                  let v = parseFloat(size_radio.closest('[data-eq]').getAttribute('data-eq'));
                  if (v > 1) {
                    href_value += '?size='+v;
                  }
                  window.location = href_value;
                }
              } else {
                window.location = href_value;
              }

          });
        });
      }
    }
  },

  autoAvailabilitySearch: {
    init: function() {
      if (document.body.classList.contains('template-collection')) {
        const searchParams = new URLSearchParams(window.location.search);
        console.log(searchParams.toString());
        if (searchParams.toString() != '' && !searchParams.has('filter.v.availability')) {
          searchParams.append('filter.v.availability', '1');
          const newUrl = new URL(window.location.href);
          newUrl.search = searchParams;
          window.location.href = newUrl;
        }
      }
    }
  },
  
  init: function() {
    app.cookiesPopup.init();
    app.cartPage.init();
		app.paymentButtons.init();
    app.mBtns.init();
    app.mProductBtns.init();
    app.autoAvailabilitySearch.init();
  }
}

window.app = app;
window.app.init();

// document.addEventListener("DOMContentLoaded", function(event) {
// 	$(document).on( "change", "#productTermsCheck", function(e) {
// 		if ( $("#productTermsCheck").is(":checked") ) {
// 			$(".shopify-payment-button__button").addClass("active");
// 		} else {
// 			$(".shopify-payment-button__button").removeClass("active");
// 		}
// 	});
// });
